module.exports = __webpack_public_path__ + "img/md-backspace.78d27839.svg";